/**
 * Ô chọn "Thành phần đất" của Vườn.
 *
 * Ba nhóm cấp phối lấy từ `@farmer/audit-rules` chứ không khai lại ở đây: cùng một danh
 * sách đó là điều kiện `@IsIn` của `CreatePlotDto`, nên chép tay bản thứ hai là tự tạo
 * ra tình huống chọn được nhưng máy chủ trả 422.
 *
 * Trước 2026-08-23 đây là ô text tự do ("Loại đất"). Vườn tạo từ trước có thể có giá trị
 * ngoài ba nhóm — hoặc rỗng — nên ô chọn phải giữ được trạng thái "chưa phân loại" thay
 * vì âm thầm hiện mặc định: hiện mặc định là ghi vào DB một phân loại chưa ai xác nhận,
 * chỉ vì có người mở hộp thoại Sửa vườn ra xem.
 */
import { SOIL_TYPES, DEFAULT_SOIL_TYPE, SOIL_TYPE_INCLUDES, isSoilType } from '@farmer/audit-rules';
import { esc } from './util.js';

export { SOIL_TYPES, DEFAULT_SOIL_TYPE, SOIL_TYPE_INCLUDES, isSoilType };

export const SOIL_TYPE_REQUIRED_MESSAGE = 'Chọn thành phần đất của vườn.';

/** Gợi ý các loại đất chi tiết thuộc một nhóm. Giá trị lạ/rỗng → câu hướng dẫn chọn. */
export function soilTypeHint(value) {
  if (!isSoilType(value)) return 'Chọn nhóm cấp phối đất của vườn.';
  return `Gồm: ${SOIL_TYPE_INCLUDES[value]}.`;
}

/**
 * @param {object} [opts]
 * @param {string|null} [opts.value] - giá trị đang lưu; bỏ trống = dùng mặc định (tạo mới).
 * @param {boolean} [opts.allowUnclassified] - cho phép hiện trạng "chưa phân loại" của
 *   vườn cũ. Chỉ bật ở hộp thoại Sửa vườn; form Thêm vườn luôn có mặc định nên không cần.
 */
export function soilTypeSelectHtml({ value = DEFAULT_SOIL_TYPE, allowUnclassified = false } = {}) {
  const known = isSoilType(value);
  const legacy = !known && value != null && String(value).trim() !== '' ? String(value) : null;
  const selected = known ? value : null;

  const unclassified = allowUnclassified && !known
    ? `<option value="" selected>${legacy ? `— Chưa phân loại: ${esc(legacy)} —` : '— Chưa chọn —'}</option>`
    : '';

  return `<div class="form-row">
    <label for="soilTypeField">Thành phần đất *</label>
    <select id="soilTypeField" name="soilType" required data-soil-select>
      ${unclassified}
      ${SOIL_TYPES.map(
        (t) => `<option value="${esc(t)}"${selected === t ? ' selected' : ''}>${esc(t)}</option>`,
      ).join('')}
    </select>
    <p class="hint-text" data-soil-hint>${esc(soilTypeHint(selected))}</p>
  </div>`;
}

/** Cập nhật dòng gợi ý khi đổi lựa chọn. Gọi sau khi HTML đã vào DOM. */
export function attachSoilTypeHint(scope) {
  const select = scope.querySelector('[data-soil-select]');
  const hint = scope.querySelector('[data-soil-hint]');
  if (!select || !hint) return;
  select.addEventListener('change', () => {
    hint.textContent = soilTypeHint(select.value);
  });
}
